angular.module("acl.visualizer.biView", [
  "acl.common.event",
  "acl.visualizer.charts",
  "acl.visualizer.dataModel",
  "acl.visualizer.statistics",
  "templates-visualizer",
]);
